import React from "react";
import { AlertTriangle, ChevronRight, CalendarClock } from "lucide-react";
import { TRY, trDate } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function OverdueBanner({ data, goTo }) {
  if (!data) return null;
  const supCount = data.supplier_count || 0;
  if (data.customer_count === 0 && supCount === 0) {
    return (
      <Card data-testid="overdue-banner-clear" className="p-4 flex items-center gap-3 border-emerald-500/30 bg-emerald-500/5">
        <CalendarClock className="h-5 w-5 text-emerald-400" />
        <div className="text-sm">
          <span className="font-semibold text-emerald-400">Günlük vade özeti:</span> Vadesi geçen alacak yok.
          {data.upcoming_7d > 0 && <span className="text-muted-foreground"> Önümüzdeki 7 günde vadesi gelen: <b className="font-mono">{TRY(data.upcoming_7d)}</b></span>}
        </div>
      </Card>
    );
  }
  return (
    <Card data-testid="overdue-banner" className="p-4 sm:p-5 border-rose-500/40 bg-rose-500/5">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-rose-500/15 text-rose-400 flex items-center justify-center shrink-0 animate-pulse">
            <AlertTriangle className="h-5 w-5" />
          </div>
          <div>
            <div className="font-heading font-semibold text-rose-400">
              Günlük Vade Uyarısı — {data.customer_count > 0 && `${data.customer_count} müşteride vadesi geçen alacak`}
              {data.customer_count > 0 && supCount > 0 && " · "}
              {supCount > 0 && `${supCount} tedarikçiye vadesi geçen borç`}
            </div>
            <div className="text-sm text-muted-foreground mt-0.5">
              {data.customer_count > 0 && <>Alacak: <b className="font-mono text-foreground">{TRY(data.total_overdue)}</b></>}
              {supCount > 0 && <> {data.customer_count > 0 && "· "}Tedarikçi borcu: <b className="font-mono text-amber-400">{TRY(data.supplier_total_overdue)}</b></>}
              {data.upcoming_7d > 0 && <> · 7 gün içinde vadesi gelen: <b className="font-mono text-foreground">{TRY(data.upcoming_7d)}</b></>}
            </div>
          </div>
        </div>
        <button data-testid="overdue-banner-goto-ledger" onClick={() => goTo && goTo("ledger")}
          className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline">
          Cari hesaplara git <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        {data.items.slice(0, 6).map((it) => (
          <div key={it.customer_id} data-testid={`overdue-item-${it.customer_id}`}
            className="flex items-center justify-between rounded-lg bg-card/70 border border-border px-3 py-2">
            <div className="min-w-0">
              <div className="text-sm font-medium truncate"><span className="text-[10px] uppercase text-muted-foreground mr-1.5">Alacak</span>{it.name}</div>
              <div className="text-[11px] text-muted-foreground">
                En eski vade {trDate(it.oldest_due)} · <span className="text-rose-400 font-semibold">{it.days_overdue} gün geçti</span>
              </div>
            </div>
            <div className="font-mono text-sm font-bold text-rose-400 whitespace-nowrap ml-3">{TRY(it.overdue_amount)}</div>
          </div>
        ))}
        {(data.supplier_items || []).slice(0, 6).map((it) => (
          <div key={it.supplier_id} data-testid={`overdue-supplier-${it.supplier_id}`}
            className="flex items-center justify-between rounded-lg bg-card/70 border border-amber-400/30 px-3 py-2">
            <div className="min-w-0">
              <div className="text-sm font-medium truncate"><span className="text-[10px] uppercase text-amber-400 mr-1.5">Borç</span>{it.name}</div>
              <div className="text-[11px] text-muted-foreground">
                En eski vade {trDate(it.oldest_due)} · <span className="text-amber-400 font-semibold">{it.days_overdue} gün geçti</span> · {it.count} fatura
              </div>
            </div>
            <div className="font-mono text-sm font-bold text-amber-400 whitespace-nowrap ml-3">{TRY(it.overdue_amount)}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
